<template>
  <div>
    <v-autocomplete
        v-model="friends"
        :disabled="true"
        :items="people"
        item-title="name"
        item-value="name"
        label="Buscar..."
        min-width="800"
        prepend-inner-icon="mdi-magnify"
        variant="solo-filled"
        class="global-search"
        density="compact"
        :hide-details="true"
    ><!--:disabled="isUpdating"-->
        <template v-slot:chip="{ props, item }">
        <v-chip
            v-bind="props"
            :prepend-avatar="item.raw.avatar"
            :text="item.raw.name"
        ></v-chip>
        </template>

        <template v-slot:item="{ props, item }">
        <v-list-item
            v-bind="props"
            :prepend-avatar="item.raw.avatar"
            :subtitle="item.raw.group"
            :title="item.raw.name"
        ></v-list-item>
        </template>
    </v-autocomplete>
  </div>
</template>

<script>
export default {

}
</script>

<style>
.global-search .v-field{
    box-shadow: none !important;
}
.global-search .v-field__prepend-inner{
    padding:0px 25px 0px 10px;
}
</style>